/**
 * This file is part of the "box" project.
 *
 * (c) Alex Buturlakin alexbuturlakin@gmail.com
 */

;(function($) {

  // copy - paste from main.js, this code needs refactoring
  function validateContact(form) {
    var priPhoneEl = form.find('#contactLanding');
    var contactFax = form.find('#contactFax');
    var streetEl   = form.find('#contactStreet');
    var cityEl     = form.find('#contactCity');
    var countryEl  = form.find('#contactCountry');
    var zipEl      = form.find('#contactZip');

    if(0 == priPhoneEl.length && 0 == contactFax.length && 0 == cityEl.length) {
      return true;
    }

    var street     = streetEl.val();
    var city       = cityEl.val();
    var country    = countryEl.val();
    var zip        = zipEl.val();
    var phone1     = form.find('#tel1').val();
    var phone2     = form.find('#tel2').val(validatePerf(form.find('#tel2').val())).val();
    var phone3     = form.find('#tel3').val();
    var fax1       = form.find('#fax1').val();
    var fax2       = form.find('#fax2').val(validatePerf(form.find('#fax2').val())).val();
    var fax3       = form.find('#fax3').val();
    priPhoneEl.val(phone3 + ' ' + phone2 + ' ' + phone1);
    contactFax.val(fax3 + ' ' + fax2 + ' ' + fax1);

    var priPhone = priPhoneEl.val();
    var errors   = '';
    var ct       = true;

    form.find('input').each(function () {
      if (!ctype_print($(this).val())) {
        ct = false;
      }
    });

    if (!ct) {
      errors += $.translate('English Only') + '\n';
    }

    if (priPhone === '' || priPhone.length < 13 || !/[0-9\s]+/.test(priPhone)) {
      priPhoneEl.parent().addClass('has-error');
      errors += $.translate('Primary phone is required') + '\n';
    } else {
      priPhoneEl.parent().removeClass('has-error');
    }

    if (street === '' || street.length < 2 || !/[0-9]/.test(street)) {
      streetEl.parent().addClass('has-error');
      errors += $.translate('Street is required') + '\n';
    } else {
      streetEl.parent().removeClass('has-error');
    }

    if (city === '' || city.length < 2 || /[0-9]/.test(city)) {
      cityEl.parent().addClass('has-error');
      errors += $.translate('City is required') + '\n';
    } else {
      cityEl.parent().removeClass('has-error');
    }

    if ($.trim(zip) === '') {
      zipEl.parent().addClass('has-error');
      errors += $.translate('Zip is required') + '\n';
    } else if (!window.isValidZipForCountry(zip, country)) {
      zipEl.parent().addClass('has-error');
      errors += $.translate('Zip is invalid') + '\n';
    } else {
      zipEl.parent().removeClass('has-error');
    }

    if (country === '') {
      countryEl.parent().addClass('has-error');
      errors += $.translate('Country is required') + '\n';
    } else {
      countryEl.parent().removeClass('has-error');
    }

    if (errors !== '') {
      $('#updatecnt-errors').html(nl2br(errors, true)).removeClass('hidden');

      return false;
    } else {
      $('#updatecnt-errors').addClass('hidden');

      return true;
    }
  }

  $(document).ready(function(e) {
    // change domain contacts
    $(document).on('click', '.update-cnt', function (e) {
      e.preventDefault();
      var uid = $(this).closest('tr').data('uid');
      $.get(Storage.getData('app_url') + 'domain/updatecnt/' + uid, function (response) {
        if (3 == response.status) {
          window.location = Storage.getData('app_url') + 'user/login';
          return;
        }

        if(0 == response.status) {
          return;
        }

        $.fancybox.open({
          type: 'iframe',
          padding: 0,
          content: response.html,
          afterShow: function () {
            $('#saveCnt').click(function (e) {
              e.preventDefault();
              var form = $(this).closest('form');
              $(this).button('loading');
              if(validateContact(form)) {
                $.post(form.attr('action') + '/' + uid, form.serialize(), function (r) {
                  r = JSON.parse(r);
                  if (r.status == 1) {
                    $('#domainflash').html(r.msg).removeClass('hidden');
                    $('#updatecnt-errors').addClass('hidden');
                    $.fancybox.close();
                  }
                  if (r.status == 0) {
                    $('#updatecnt-errors').html(nl2br(r.msg, true)).removeClass('hidden');
                    $('#contactEmailVerify').prop('disabled', true);
                    $('#VerifyEmailSection').addClass('hidden');
                    $('#VerifyEmailSection').removeClass('has-error');
                    $('#updatecnt-info').addClass('hidden');
                    $('#saveCnt').button('reset');
                  }
                  if (r.status == 4) {
                      $('#updatecnt-errors').addClass('hidden');
                      $('#updatecnt-info').html(nl2br(r.msg, true)).removeClass('hidden');
                      $('#contactEmailVerify').prop('disabled', false);
                      $('#VerifyEmailSection').removeClass('hidden');
                      $('#VerifyEmailSection').addClass('has-error');
                      $('.fancybox-overlay').scrollTop($('#VerifyEmailSection').offset().top);
                      $('#saveCnt').button('reset');
                  }
                })
              }else{
                $('#saveCnt').button('reset');
              }
            })
          }
        })
      });
    });

    // domain after transfer set contact
    if(Storage.hasData('newTransferedDomain')) {
      var uid = Storage.getData('newTransferedDomain'),
          modalCallback = function(params) {

      // copy - paste from user/account.php inline js code
      var msg = typeof undefined === typeof params.msg ? false : params.msg,
          ec  = $('#updatecnt-errors'),
          uid = params.uid;

      if (false != msg) {
        $('#updatecnt-suc').html(msg).removeClass('hidden');
      }

      $('#saveCnt').click(function (e) {
        e.preventDefault();

        var form   = $(this).closest('form'),
            submit = $(this);

        ec.addClass('hidden');

        submit.buttonLoading('loading');

        if(validateContact(form))

        $.post(Storage.getData('app_url') + 'domain/transfer-rcv/' + uid, $('#updatecnt').serialize(), function (response) {

          submit.buttonLoading('reset');

          if (response.status == 1) {
            $('#domainflash').html(response.msg).removeClass('hidden');
            ec.addClass('hidden');
            $.fancybox.close();
          }

          if (response.status == 0) {
            ec.html(nl2br(response.msg, true)).removeClass('hidden');
          }

          if (response.status == 2) {
            ec.addClass('hidden');
            $.fancybox.close();

            $.showXHRModal(Storage.getData('app_url') + 'domain/updatecnt/' + response.next, modalCallback, {'uid': response.next, 'msg': response.msg});
          }
        });
      });
    };

      $.showXHRModal(Storage.getData('app_url') + 'domain/updatecnt/' + uid, modalCallback, {'uid': uid});
    }
  });
})(jQuery);